export default "__VITE_ASSET__c3c331f9__"